import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Lock, CheckCircle, Warning, SignIn, UserCircle } from '@phosphor-icons/react';

export const AuthCheckingScreen = () => (
  <div className="min-h-screen bg-[#E8E9EB] dark:bg-[#121212] flex items-center justify-center">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-[#2B4C6F] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-neutral-600 dark:text-neutral-400 font-medium">Checking access...</p>
    </div>
  </div>
);

export const AccessDeniedScreen = ({ currentUser }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#E8E9EB] dark:bg-[#121212] flex items-center justify-center p-4">
      <div className="max-w-lg w-full bg-white dark:bg-[#0F172A] border-4 border-black dark:border-white shadow-[8px_8px_0px_#000] dark:shadow-[8px_8px_0px_#2B4C6F]">
        <div className="p-6 bg-[#2B4C6F] border-b-4 border-black dark:border-white">
          <div className="flex items-center justify-center gap-3">
            <div className="w-14 h-14 bg-white/20 border-2 border-white/30 flex items-center justify-center">
              <Lock size={32} weight="bold" className="text-white" />
            </div>
          </div>
        </div>
        
        <div className="p-8 text-center">
          <h1 className="text-2xl font-black text-neutral-900 dark:text-white uppercase mb-3">
            Contractor Access Only
          </h1>
          
          <p className="text-neutral-600 dark:text-neutral-400 mb-6">
            The AI Pricing Tool is exclusively available to registered contractors. 
            {!currentUser 
              ? " Sign in with your contractor account to access this feature."
              : " Your current account is registered as a worker."
            }
          </p>
          
          <div className="bg-neutral-100 dark:bg-neutral-800 border-2 border-black dark:border-white p-4 mb-6 text-left">
            <p className="font-bold text-neutral-900 dark:text-white uppercase text-xs tracking-wider mb-3">
              What you'll get:
            </p>
            <ul className="space-y-2 text-sm text-neutral-600 dark:text-neutral-400">
              {[
                'AI-powered instant pricing estimates',
                'Material breakdowns & quantities',
                'Good/Better/Best tiered pricing',
                'Save & compare estimates',
                'Professional quote generation'
              ].map((feature) => (
                <li key={feature} className="flex items-center gap-2">
                  <CheckCircle size={16} weight="bold" className="text-emerald-500" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          
          <div className="space-y-3">
            {!currentUser ? (
              <>
                <Button
                  onClick={() => navigate('/login')}
                  className="w-full h-12 bg-[#2B4C6F] hover:bg-[#203A55] text-white font-bold uppercase tracking-wider border-2 border-black shadow-[4px_4px_0px_#000] rounded-none"
                  data-testid="login-btn"
                >
                  <SignIn size={20} weight="bold" className="mr-2" />
                  Sign In as Contractor
                </Button>
                <Button
                  onClick={() => navigate('/signup?type=contractor')}
                  variant="outline"
                  className="w-full h-12 font-bold uppercase tracking-wider border-2 border-black dark:border-white rounded-none"
                  data-testid="signup-btn"
                >
                  <UserCircle size={20} weight="bold" className="mr-2" />
                  Create Contractor Account
                </Button>
              </>
            ) : (
              <>
                <div className="p-3 bg-amber-100 dark:bg-amber-900/30 border-2 border-amber-500 text-sm text-amber-800 dark:text-amber-200 mb-4">
                  <Warning size={16} weight="bold" className="inline mr-2" />
                  You're signed in as: <strong>{currentUser.email}</strong> (Worker account)
                </div>
                <Button
                  onClick={() => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    navigate('/login');
                  }}
                  className="w-full h-12 bg-[#2B4C6F] hover:bg-[#203A55] text-white font-bold uppercase tracking-wider border-2 border-black shadow-[4px_4px_0px_#000] rounded-none"
                >
                  <SignIn size={20} weight="bold" className="mr-2" />
                  Sign In with Different Account
                </Button>
              </>
            )}
            
            <button
              onClick={() => navigate('/')}
              className="w-full py-3 text-neutral-500 hover:text-neutral-700 dark:hover:text-neutral-300 font-medium text-sm uppercase tracking-wider"
            >
              Return to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
